import { IFailedSection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';

const Autolinker = require('autolinker');

interface IRegistrationFailureModel {
  failed_sections: Record<string, IFailedSection>;
}
export class RegistrationFailureModel {
  private _model: IRegistrationFailureModel = {
    failed_sections: {}
  };

  clear(): RegistrationFailureModel {
    this._model.failed_sections = {};
    return this;
  }

  put(failedSection: IFailedSection): RegistrationFailureModel {
    failedSection.message = Autolinker.link(failedSection.message, {
      newWindow: true,
      stripPrefix: true,
      truncate: 30,
      urls: {
        tldMatches: false
      },
      className: 'text-link'
    });
    this._model.failed_sections[failedSection.id] = failedSection;
    return this;
  }

  del(sectionId: number) {
    this._model.failed_sections = _4.omit(this._model.failed_sections, sectionId);
    return this;
  }

  read(): IRegistrationFailureModel {
    return this._model;
  }

  get(sectionId: number) {
    return this._model.failed_sections[sectionId];
  }
}

angular.module('capability-ng-scheduler').service('ngRegistrationFailureModel', RegistrationFailureModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/models/registration_failure_model.ts